import { buildClassesHook } from '../../../helpers/styles';
import { Theme } from '../../../theme';

export const useClasses = buildClassesHook((theme: Theme) => ({
    formContainer: {
        padding: '2em 2em',
        borderRadius: '1em',
        maxWidth: 1400,
        marginTop: '4.5rem',
    },
    storeSelector: {
        maxWidth: 160,
    },
    actionRow: {
        top: '4.5rem',
        position: 'sticky',
        backgroundColor: theme.colors.white,
        zIndex: 3,
        padding: '0 1rem',
        borderBottom: `1px solid ${theme.colors.lightGrey}`,
    },
}));
